var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"alert-box alert",class:'alert-'+_vm.type},[_c('div',{staticClass:"flex-1"},[_c('font-awesome-icon',{staticClass:"w-6 h-6 mx-2",attrs:{"icon":"info-circle"}}),_c('span',{},[_vm._v(" "+_vm._s(_vm.message)+" ")])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }